module.exports = __webpack_public_path__ + "static/media/Icon Dev.c44daf85.svg";